import { AllureQuarterlyPlanStateTypes, AllureQuarterlyPlanActionTypes } from "./AllureQuarterlyPlan.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureQuarterlyPlanStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureQuarterlyPlanReducer = (
  state: AllureQuarterlyPlanStateTypes = INITIAL_STATE,
  action: any
): AllureQuarterlyPlanStateTypes => {
  switch (action.type) {
    case AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureQuarterlyPlanReducer;
